import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["menu", "button"]

  connect() {
    this.clickOutsideHandler = (event) => {
      if (!this.element.contains(event.target)) {
        this.close()
      }
    }
    document.addEventListener("click", this.clickOutsideHandler)

    this.closeOthersHandler = (event) => {
      if (event.detail.openedController !== this) {
        this.close()
      }
    }
    window.addEventListener("cell-menu:opened", this.closeOthersHandler)

    this.scrollHandler = () => this.close()
  }

  disconnect() {
    document.removeEventListener("click", this.clickOutsideHandler)
    window.removeEventListener("cell-menu:opened", this.closeOthersHandler)
    this.removeScrollListener()
  }

  toggle(event) {
    event.preventDefault()
    event.stopPropagation()

    if (this.menuTarget.classList.contains("hidden")) {
      const customEvent = new CustomEvent("cell-menu:opened", {
        detail: { openedController: this }
      })
      window.dispatchEvent(customEvent)

      // this.positionMenu()
      this.menuTarget.classList.remove("hidden")
      this.addScrollListener()
    } else {
      this.close()
    }
  }

  close() {
    this.menuTarget.classList.add("hidden")
    this.removeScrollListener()
  }

  positionMenu() {
    const btn = this.buttonTarget
    const rect = btn.getBoundingClientRect()
    const menu = this.menuTarget

    // Show temporarily to measure
    menu.style.visibility = "hidden"
    menu.classList.remove("hidden")
    const menuRect = menu.getBoundingClientRect()
    menu.classList.add("hidden")
    menu.style.visibility = ""

    // Position below the button, aligned to the right
    let top = rect.bottom + 4
    let left = rect.right - menuRect.width

    // Keep within viewport
    if (top + menuRect.height > window.innerHeight) {
      top = rect.top - menuRect.height - 4
    }
    if (left < 8) {
      left = 8
    }

    menu.style.top = `${top}px`
    menu.style.left = `${left}px`
  }

  addScrollListener() {
    // Find the scrollable parent to close on scroll
    const scrollParent = this.element.closest(".overflow-x-auto") || this.element.closest(".overflow-y-auto")
    if (scrollParent) {
      this.scrollParent = scrollParent
      scrollParent.addEventListener("scroll", this.scrollHandler)
    }
    window.addEventListener("scroll", this.scrollHandler)
  }

  removeScrollListener() {
    if (this.scrollParent) {
      this.scrollParent.removeEventListener("scroll", this.scrollHandler)
      this.scrollParent = null
    }
    window.removeEventListener("scroll", this.scrollHandler)
  }
}
